import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchChartLines, fetchCharts } from "../../api/charts";

export const fetchChartsAsync = createAsyncThunk("charts", async ({ vesselId }) => {
  const { charts } = await fetchCharts(vesselId);
  return charts;
});

export const fulfilledFetchChartsAsync = (state, action) => {
  state.charts = action.payload;
  state.isChartsFetching = false;
};

export const rejectedFetchChartsAsync = (state, action) => {
  state.isChartsFetching = false;
};

export const pendingFetchChartsAsync = (state, action) => {
  state.isChartsFetching = true;
};

export const fetchChartLinesAsync = createAsyncThunk("chart/lines", async ({ vesselId, chartId }) => {
  const { chartLines } = await fetchChartLines(vesselId, chartId);
  return {
    id: chartId,
    lines: chartLines,
  };
});

export const fulfilledFetchChartLinesAsync = (state, action) => {
  state.chartLines = {
    ...state.chartLines,
    [action.payload.id]: action.payload.lines,
  };
};

export const rejectedFetchChartLinesAsync = (state, action) => {
};

export const pendingFetchChartLinesAsync = (state, action) => {
};
